import React, { useState,useEffect } from "react";
import toast from "react-hot-toast";

const OtpValidate = ({ onClose, onVerify, onResend, mobile }) => {
  const [otp, setOtp] = useState(""); // single string OTP
  // resend otp 
  const [timer, setTimer] = useState(30); 
  const [canResend, setCanResend] = useState(false); 
  const [isResending, setIsResending] = useState(false);
  console.log("Current OTP:", otp);

  //   const handleVerify = () => {
  //     if (otp.length < 4) {
  //       toast.error("Please enter 4 digit OTP");
  //       return;
  //     }
  //     onVerify(otp);
  //   };

  const maskedMobile =
    mobile && mobile.length >= 4
      ? mobile.slice(0, -4).replace(/./g, "X") + mobile.slice(-4)
      : mobile;
      // resend otp 
      useEffect(() => {
  if (timer > 0) {
    const interval = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  } else {
    setCanResend(true);
  }
}, [timer]);

const handleResendOtp = async () => {
  if (!canResend || isResending) return;
  
  setIsResending(true);
  setOtp(""); // Clear current OTP input
  
  try {
    await onResend(); // Call the parent's resend function
    setTimer(30); // Reset timer
    setCanResend(false);
    toast.success("OTP sent successfully!");
  } catch (error) {
    console.error("Resend OTP failed:", error);
    toast.error("Failed to resend OTP. Please try again.");
  } finally {
    setIsResending(false);
  }
};

const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};
// resend otp //

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          maxWidth: "450px",
          width: "100%",
          background: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          overflow: "hidden",
          fontFamily: "Arial, sans-serif",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "12px 16px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ margin: 0, color: "#00b4aa" }}>OTP Verification</h3>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
            }}
          >
            ✖
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "20px", textAlign: "center" }}>
          <p style={{ fontSize: "14px", color: "#333", marginBottom: "16px" }}>
            Please enter the one time password to verify your account.
            A code has been sent to <strong>{maskedMobile}</strong>
          </p>

          {/* OTP Input */}
          <input
            type="text"
            maxLength={6} // in case OTP is 4-6 digits
            value={otp}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, ""); // allow only numbers
              setOtp(value);
            }}
            style={{
              width: "80%",
              padding: "10px",
              fontSize: "18px",
              textAlign: "center",
              border: "1px solid #ccc",
              borderRadius: "6px",
              marginBottom: "20px",
              outline: "none",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#00b4aa")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
          />

          {/* Verify Button */}
          <button
            onClick={() => onVerify(otp)}
            style={{
              width: "40%",
              backgroundColor: "#00b4aa",
              border: "none",
              borderRadius: "6px",
              padding: "10px",
              color: "#fff",
              fontWeight: "600",
              fontSize: "16px",
              cursor: "pointer",
              marginBottom: "12px",
            }}
          >
            Verify OTP
          </button>
          {/* resend otp */}
          <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "14px",
  }}
>
  <span style={{ color: "#666" }}>Didn't receive the code?</span>
  {canResend ? (
    <button
      onClick={handleResendOtp}
      disabled={isResending}
      style={{
        background: "none",
        border: "none",
        color: "#00b4aa",
        fontWeight: "600",
        cursor: isResending ? "not-allowed" : "pointer",
        textDecoration: "underline",
        fontSize: "14px",
        opacity: isResending ? 0.6 : 1,
      }}
    >
      {isResending ? "Sending..." : "Resend OTP"}
    </button>
  ) : (
    <span style={{ color: "#00b4aa", fontWeight: "600" }}>
      Resend in {formatTime(timer)}
    </span>
  )}
</div>
          {/* resend otp  */}
        </div>
      </div>
    </div>
  );
};

export default OtpValidate;
